import { NamedModelHistory } from 'api/Exec/types';
import { modelsUrl } from 'app/consts/urls';
import { pluralize } from 'app/helpers/pluralize';

import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Tag, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React from 'react';

const useColumns = (onDetailsClick: (model: NamedModelHistory) => void) => {
  const columns: ColumnsType<NamedModelHistory> = [
    {
      title: 'History ID',
      dataIndex: 'historyId',
      key: 'historyId',
    },
    {
      title: 'Name',
      dataIndex: 'modelName',
      key: 'modelName',
    },
    {
      title: 'API name',
      dataIndex: 'modelApiName',
      key: 'modelApiName',
    },
    {
      title: 'Image tag',
      key: 'modelImageTag',
      render: (_, { modelImageTag, modelId }) => {
        return <Typography.Link href={`${modelsUrl}/?model=${modelId}`} target="_blank">{modelImageTag}</Typography.Link>;
      },
    },
    {
      title: 'Sandbox',
      key: 'sandbox',
      align: 'center',
      render: (_, { isSandbox }) => {
        return isSandbox ? <CheckCircleFilled style={{ color: '#00B96B' }} /> : <CloseCircleFilled style={{ color: '#D9D9D9' }} />;
      },
    },
    {
      title: 'CV',
      key: 'clinicalValidated',
      align: 'center',
      render: (_, { clinicalValidated }) => {
        return clinicalValidated ? <CheckCircleFilled style={{ color: '#00B96B' }} /> : <CloseCircleFilled style={{ color: '#D9D9D9' }} />;
      },
    },
    {
      title: 'Usage',
      key: 'usage',
      render: (_, { usedInOrgs }) => pluralize(usedInOrgs, 'org'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_, { enabled, id }) => {
        return (
          <Tag color={enabled ? 'purple' : 'error'} key={id}>
            {enabled ? 'Enabled' : 'Disabled'}
          </Tag>
        );
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, history) => <Typography.Link ellipsis onClick={() => onDetailsClick(history)}>Details</Typography.Link>,
    },
  ];

  return { columns };
};

export default useColumns;
